import { grpc } from '@improbable-eng/grpc-web';
import * as serviceProto from '../Proto/service/service_pb';

// Create the gRPC method descriptors that match the @improbable-eng/grpc-web format
// This is needed because the generated code uses a different format than what @improbable-eng/grpc-web expects

// Method descriptor for the GetResponse streaming method
export const GetResponse = {
  methodName: 'GetResponse',
  service: {
    serviceName: 'service.ConvaiService'
  },
  requestStream: true,
  responseStream: true,
  requestType: serviceProto.GetResponseRequest,
  responseType: serviceProto.GetResponseResponse
};

// Method descriptor for SubmitFeedback
export const SubmitFeedback = {
  methodName: 'SubmitFeedback',
  service: {
    serviceName: 'service.ConvaiService'
  },
  requestStream: false,
  responseStream: false,
  requestType: serviceProto.FeedbackRequest,
  responseType: serviceProto.FeedbackResponse
};

// Export the ConvaiService methods as a single object to match the import pattern
export const ConvaiService = {
  GetResponse,
  SubmitFeedback
};

// Export the proto for convenience
export const proto = serviceProto;